import { createContext } from "react";

import type useInstitutionFormIdentityById from "src/hooks/data/load/useInstitutionFormIdentityById";

/**
 * Describes the institution form identity loader state and its refresh/cache actions.
 */
export interface IInstitutionFormIdentityContext extends ReturnType<
    typeof useInstitutionFormIdentityById
> {}

/**
 * Shares institution form identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export default createContext<IInstitutionFormIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});
